<script>

import { navigate } from "svelte-routing";
    
    
    let username=localStorage.getItem("username");
    let email =localStorage.getItem("email")
    let profile=localStorage.getItem("profile")
    function logout(){
        localStorage.clear("username");
        localStorage.clear("email");
        localStorage.clear("token");
        localStorage.clear("profile");

        navigate('/')

    } 
    
</script>

<!-- Main Menu -->
<div class="sidebar">
    <div class="logo">
        <a href="/">
            <span class="logo-emblem"><img
                    src="https://res.cloudinary.com/kalaputri/image/upload/v1612700696/Email/Adobe_Post_20210207_1753260.4727559461026627_ccy1mv.png"
                    alt="BA" /></span>
            <span class="logo-full">KalaPutri</span>
        </a>
    </div>
    <ul id="sidebarCookie">
        <li class="spacer" />
        <li class="profile">
            <span class="profile-image">
                <img
                    src="{profile}"
                    alt="profile" />
            </span>
            <span class="profile-name"> {username} </span>
            <span class="profile-info"> {email} </span>
        </li>
        <li class="spacer" />
        <li class="title">
            <i class="feather icon-more-horizontal" />
            <span class="menu-title">Main</span>
        </li>
        <li class="nav-item">
            <a
                class="nav-link wave-effect collapsed"
                data-parent="#sidebarCookie"
                data-toggle="collapse"
                href="#navPageLayouts"
                aria-expanded="false"
                aria-controls="page-layouts">
                <i class="feather icon-sidebar" />
                <span class="menu-title">Create Order</span>
                <i class="feather icon-chevron-down down-arrow" />
            </a>
            <div class="collapse" id="navPageLayouts">
                <ul class="flex-column sub-menu">
                    <li class="nav-item">
                        <a
                            class="nav-link wave-effect"
                            href="/order-welcomemail">
                            <i class="feather icon-layout" />
                            <span class="menu-title">Welcome Mail</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link wave-effect"
                            href="/order-create">
                            <i class="feather icon-bold" />
                            <span class="menu-title">Create order</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link wave-effect"
                            href="/order-update">
                            <i class="feather icon-pause" />
                            <span class="menu-title">Update Order</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link wave-effect"
                            href="/order-cancel">
                            <i class="feather icon-delete" />
                            <span class="menu-title">Cancel Order</span>
                        </a>
                    </li>
                </ul>
            </div>
        </li>
        <li class="spacer" />
        <li class="title">
            <i class="feather icon-more-horizontal" />
            <span class="menu-title">settings</span>
        </li>
        <li class="nav-item">
            <!-- svelte-ignore a11y-missing-attribute -->
            <a
        on:click={()=>logout()}
                class="nav-link wave-effect nav-single">
                <i class="feather icon-unlock" />
                <span class="menu-title">logout</span>
            </a>
        </li>
    </ul>
</div>